import React from 'react';
import './Team.css';

import { Heading, TeamItem } from '../../../components';
import { team } from '../../../constants';



const Team = () => {

  return (
    <section className='team'>

      {/* Section heading */}
      <Heading title={'Our Team'} subTitle={'meet our team'} />

      <div className='box-container'>
        {
          // Map over the team array to render each team Member
          team.map((item) => {
            return (
              <TeamItem key={item.id} team={item} /> 
            )
          })
        }
      </div>
    </section>
  )

}

export default Team;